var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 3.36364H28.9V0H25.5V3.36364H8.5V0H5.1V3.36364H3.4C1.53 3.36364 0 4.87727 0 6.72727V33.6364C0 35.4864 1.53 37 3.4 37H30.6C32.47 37 34 35.4864 34 33.6364V6.72727C34 4.87727 32.47 3.36364 30.6 3.36364ZM30.6 33.6364H3.4V15.1364H30.6V33.6364ZM30.6 11.7727H3.4V6.72727H30.6V11.7727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCalender);
export default __webpack_public_path__ + "static/media/event-calender.da07d1748ccc2d11fb035bb1bafe7423.svg";
export { ForwardRef as ReactComponent };